import React from "react";

import DesktopSyncIcon from "../../../../common/icons/integrations/DesktopSyncIcon";
import GenericReconnectCard from "../GenericReconnectCard";
import { INTEGRATION_KEYS } from "../../../../integrations/IntegrationsHelper";
import { capitalize } from 'lodash';

export default function DesktopReconnectCard({ controller, device }) {
  const env = device.device_id
    ? capitalize(device.device_id.split(":")[0])
    : null;

  return (
    <GenericReconnectCard
      controller={controller}
      integrationType={INTEGRATION_KEYS.desktop}
      IconTag={DesktopSyncIcon}
      title={device.name}
      env={env}
      description="Reconnect to continue getting the best insights from your desktop."
    />
  );
}
